var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0.700195L14 12.7911H0L7 0.700195ZM6.57643 8.91143C6.60021 8.92745 6.62696 8.93546 6.65669 8.93546H7.45032C7.48004 8.93546 7.50382 8.92745 7.52166 8.91143C7.54543 8.89006 7.55732 8.86603 7.55732 8.83932L7.69108 5.34633C7.69108 5.31963 7.67919 5.29826 7.65541 5.28224C7.63758 5.26088 7.6138 5.2502 7.58408 5.2502H6.54076C6.51104 5.2502 6.48429 5.26088 6.46051 5.28224C6.44268 5.29826 6.43376 5.31963 6.43376 5.34633L6.54968 8.83932C6.54968 8.86603 6.5586 8.89006 6.57643 8.91143ZM6.49618 10.6739C6.63291 10.7914 6.80234 10.8502 7.00446 10.8502C7.20658 10.8502 7.37304 10.7914 7.50382 10.6739C7.63461 10.5511 7.7 10.3989 7.7 10.2173C7.7 10.0304 7.63461 9.87814 7.50382 9.76064C7.37898 9.64314 7.21253 9.58439 7.00446 9.58439C6.79639 9.58439 6.62696 9.64314 6.49618 9.76064C6.36539 9.87814 6.3 10.0304 6.3 10.2173C6.3 10.3989 6.36539 10.5511 6.49618 10.6739Z",
    fill: "#FFE664"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.fa4ba7496ed6de726ee88b1db6116a73.svg";
export { ForwardRef as ReactComponent };